@switch (mode()) {
  @case ('horizontal-big') {
    @if (!isLoading()) {
      <div class="d-flex align-items-center gap-pony {{ classes() }}">
        <div class="cover-container size-64 radius-medium">
          <ui-api-image
            [imageId]="store().coverImageId"
            [width]="'100%'"
            [height]="'100%'"
            [fallbackImage]="'assets/fallback/product-on-back-fallback.png'"
            [styles]="{ borderRadius: '4px' }"
          ></ui-api-image>
          <div class="logo-container radius-rounded p-tiny surface-glass-high-contrast">
            <ui-api-image
              [classes]="'radius-rounded'"
              [width]="'18px'"
              [height]="'18px'"
              [fallbackImage]="'assets/fallback/digipay-logo-24x24-fallback.svg'"
            ></ui-api-image>
          </div>
        </div>
        <div class="d-flex flex-column gap-low">
          <span class="c-2 text-onback-high">{{ store().title }}</span>
          <span class="l-3 text-onback-low">{{ store().subtitle }}</span>
        </div>
      </div>
    } @else {}
  }
  @case ('horizontal-small') {
    @if (!isLoading()) {
      <div class="d-flex align-items-center gap-small  {{ classes() }}">
        <div class="d-flex justify-content-center align-items-center radius-minus surface-back p-small">
          <ui-api-image
            [imageId]="store().logoImageId"
            [width]="'24px'"
            [height]="'24px'"
            [fallbackImage]="'assets/fallback/digipay-logo-24x24-fallback.svg'"
          ></ui-api-image>
        </div>
        <span class="c-2 text-onback-high">{{ store().title }}</span>
      </div>
    } @else {
      <div class="d-flex align-items-center gap-small">
        <lib-ngx-skeleton-loading
          [width]="'40px'"
          [height]="'40px'"
        ></lib-ngx-skeleton-loading>
        <lib-ngx-skeleton-loading
          [width]="'100px'"
          [height]="'18px'"
        ></lib-ngx-skeleton-loading>
      </div>
    }
  }
  @case ('vertical-medium') {
    @if (!isLoading()) {
      <div class="d-flex flex-column gap-small  {{ classes() }}">
        <div class="cover-container size-80 radius-medium overflow-hidden">
          <ui-api-image
            [imageId]="store().coverImageId"
            [width]="'120%'"
            [height]="'110%'"
            class="vertical-ui-image"
            [fallbackImage]="'assets/fallback/product-on-back-fallback.png'"
            [styles]="{ borderRadius: '16px', objectFit: 'cover' }"
          ></ui-api-image>
          <div class="logo-container radius-rounded p-tiny surface-glass-high-contrast">
            <ui-api-image
              [classes]="'radius-rounded'"
              [imageId]="store().logoImageId"
              [width]="'21px'"
              [height]="'21px'"
              [fallbackImage]="'assets/fallback/digipay-logo-24x24-fallback.svg'"
            ></ui-api-image>
          </div>
        </div>
        <span class="c-3 text-onback-medium">{{ store().title }}</span>
      </div>
    } @else {
      <div class="d-flex flex-column gap-small">
        <lib-ngx-skeleton-loading
          [width]="'80px'"
          [height]="'80px'"
          [borderRadius]="'16px'"
        ></lib-ngx-skeleton-loading>
        <lib-ngx-skeleton-loading
          [width]="'100%'"
          [height]="'21px'"
        ></lib-ngx-skeleton-loading>
      </div>
    }
  }
  @case ('vertical-large') {
    @if (!isLoading()) {
      <div class="position-relative pt-tiny">
        @if (store().badges && store().badges.length > 0) {
          <div class="badges">
            <ngx-badge
              [status]="store().badges[0].status"
              [type]="'text'"
              [mode]="store().badges[0].mode"
            >
              {{ store()?.badges[0].content }}
            </ngx-badge>
          </div>
        }
        <div class="d-flex flex-column  {{ classes() }}">
          <div class="cover-container size-112 radius-medium overflow-hidden mb-small">
            <ui-api-image
              [imageId]="store().coverImageId"
              [width]="'120%'"
              [height]="'110%'"
              class="vertical-ui-image"
              [styles]="{ borderRadius: '16px', objectFit: 'cover' }"
              [fallbackImage]="'assets/fallback/product-on-back-fallback.png'"
            ></ui-api-image>
            <div class="logo-container radius-rounded p-tiny surface-glass-high-contrast">
              <ui-api-image
                [classes]="'radius-rounded'"
                [imageId]="store().logoImageId"
                [width]="'24px'"
                [height]="'24px'"
                [fallbackImage]="'assets/fallback/digipay-logo-24x24-fallback.svg'"
              ></ui-api-image>
            </div>
          </div>
          <span class="st-8 text-onback-high text-wrap">{{ store().title }}</span>
          <span class="c-3 text-onback-mediums text-wrap">{{ store().subtitle }}</span>
        </div>
      </div>
    } @else {
      <div class="d-flex flex-column gap-small">
        <lib-ngx-skeleton-loading
          [width]="'80px'"
          [height]="'80px'"
          [borderRadius]="'16px'"
        ></lib-ngx-skeleton-loading>
        <lib-ngx-skeleton-loading
          [width]="'100%'"
          [height]="'21px'"
        ></lib-ngx-skeleton-loading>
      </div>
    }
  }
  @case ('logo-only') {
    <div class="d-flex flex-column align-items-center justify-content-start cursor-pointer">
      <div class="icon-only-logobox radius-rounded surface-elevated d-flex align-items-center justify-content-center p-pony">
        @if (store().auction) {
          <div class="icon-only-auction-badge">
            <ngx-badge
              [status]="'info'"
              [type]="'icon'"
              [circularIcon]="true"
              [size]="'lg'"
            >
              <ngx-icon
                [type]="'due'"
                [secondaryColor]="'#1159FC'"
                [name]="'discount'"
                [iconSize]="'24px'"
              />
            </ngx-badge>
          </div>
        }
        <ui-api-image
          [height]="'44px'"
          [width]="'44px'"
          [classes]="'radius-rounded'"
          [imageId]="store().logoImageId"
        ></ui-api-image>
      </div>
      <div class="text-align-center c-2 mt-low text-onback-medium">{{ store().title | summarize: 15 }}</div>
    </div>
  }
}
